export const defaultApodizationOptions = {
    lineBroadening: 1,
    gaussBroadening: 0,
    lineBroadeningCenter: 0,
};
